import {Residence} from './residence';
import {deserialize, deserializeAs, inheritSerialization} from 'cerialize';
import {Entity} from './entity';

@inheritSerialization(Entity)
export class Batiment extends Entity {

  @deserialize
  nom: string;
  @deserializeAs(Residence)
  residence: Residence;
}
